<script>
  let mapContainer = 0
  let timeline = []
  let partyLegend = [
    'African National Congress',
    'Democratic Alliance',
    'Inkatha Freedom Party',
    'Economic Freedom Fighters',
    'Patriotic Alliance',
    'Other Parties',
  ]
  let partyList = []
  let ttx = -1000
  let tty = -1000
  let tooltip = ''
  let colors = ['#b9cda1', '#88aee1', '#f9ea61', '#e6c8d8', '#fcce85', 'gray']
  import L from 'leaflet'
  import { provinces } from './provinces.js'
  import { municipalities } from './municipalities.js'
  import { onMount } from 'svelte'
  let mayors = []

  async function getTimeline() {
    await fetch(
      'https://api.datadesk.co.za/csvjson.php?table=dd_council_tracker_timeline_8014363'
    )
      .then((response) => response.json())
      .then((response) => {
        timeline = response.reverse()
      })
  }
  async function getMayors() {
    await fetch(
      'https://api.datadesk.co.za/json.php?table=dd_council_tracker___mayors_7743628'
    )
      .then((response) => response.json())
      .then((response) => {
        mayors = response
        // console.log(mayors)
      })
  }
  let map = null

  async function getPartyList() {
    await fetch(
      'https://api.datadesk.co.za/json.php?table=dd_council_tracker___party_glossary_5653085'
    )
      .then((response) => response.json())
      .then((response) => {
        partyList = response
      })
  }

  function addMap() {
    map = L.map('map', {
      zoomControl: true,
      scrollWheelZoom: false,
      dragging: true,
      zoomSnap: 0.1,
      center: [0, 0],
      zoom: 2,
      zoomControl: false,
      attributionControl: false,
    }).setView([-28.1018753, 24.8843883], 6)

    L.control
      .zoom({
        position: 'bottomright',
      })
      .addTo(map)

    let outline = L.geoJSON(municipalities, {
      onEachFeature: onEachFeature,
      style: mapStyle,
    }).addTo(map)

    let provs = L.geoJSON(provinces, {
      onEachFeature: onEachProvFeature,
      style: provStyle,
    }).addTo(map)

    map.fitBounds(outline.getBounds(), { padding: [10, 10] })
  }

  function onEachProvFeature() {}

  function onEachFeature(feature, layer) {
    // console.log(feature.properties.ADM3_ID)
    layer.on({
      mouseover: hover,
      mousemove: move,
      mouseout: out,
      click: click,
    })
  }
  function getPartyFullName(abbr) {
    return partyList.find((party) => party.acronym === abbr).full_name
  }

  function hover(feature) {
    let details = mayors.filter(
      (d) => d.muni_code === feature.target.feature.properties.ADM3_ID
    )[0]
    console.log(details.mayor_party)

    let partyFullName = partyList.find(
      (p) => p.acronym === details.mayor_party
    ).full_name
    tooltip = `
    <div class="tt-title">${details.municipality}</div>
    <div class="tt-row"><span class="tt-label">Hung Council (2021):</span> ${details.hung_council_2021}</div>
    <div class="tt-row"><span class="tt-label">Mayor:</span> ${details.mayor_name}</div>
    <div class="tt-row"><span class="tt-label">Party:</span> ${details.mayor_party} (${partyFullName})</div>
    <div class="tt-row"><span class="tt-label">Voter Turnout (2021):</span> ${details['2021_voter_turnout']}</div>`
    ttx = feature.originalEvent.clientX + 20
    tty = feature.originalEvent.clientY - 10
    // console.log(feature.target.feature.properties)
  }
  function move(feature) {
    console.log(feature.originalEvent.layerX)

    let xOffset = 20
    let xpos = feature.originalEvent.layerX
    console.log(mapContainer, xpos)

    if (mapContainer - feature.originalEvent.layerX < 200) {
      xOffset = -200
    }
    ttx = feature.originalEvent.clientX + xOffset
    tty = feature.originalEvent.clientY - 10
  }
  function out(feature) {
    ttx = -1000
    tty = -1000
  }
  function click() {}

  function mapStyle(feature, layer) {
    let fill = colors[5]
    let current = mayors.filter(
      (d) => d.muni_code == feature.properties.ADM3_ID
    )
    // partyList.forEach((d, i) => {
    //   if (current[0].mayor_party === d.acronym) {
    //     fill = colors[i]
    //   }
    // })
    if (current[0].mayor_party === 'ANC') {
      fill = colors[0]
    } else if (current[0].mayor_party === 'DA') {
      fill = colors[1]
    } else if (current[0].mayor_party === 'IFP') {
      fill = colors[2]
    } else if (current[0].mayor_party === 'EFF') {
      fill = colors[3]
    } else if (current[0].mayor_party === 'PA') {
      fill = colors[4]
    }

    return {
      fillColor: fill,
      color: '#000',
      weight: 0.5,
      opacity: 1,
      fillOpacity: 1,
      className: feature.properties.ADM3_ID,
    }
  }

  function provStyle(feature) {
    return {
      fillColor: 'none',
      color: '#000',
      weight: 1,
    }
  }

  onMount(() => {
    getPartyList()
    getMayors().then(() => {
      getTimeline()

      setTimeout(() => {
        addMap()
      }, 500)
    })
  })
</script>

<main>
  <div class="tooltip" style="top: {tty}px; left: {ttx}px;">
    {@html tooltip}
  </div>
  <div class="map-container" bind:clientWidth={mapContainer}>
    <div class="map-title">
      SA Municipality Tracker
      <div class="map-subhead">
        Tracking changes in local governance since 2021 local government
        elections.
      </div>
      <div class="logo">
        Data and graphics by <a href="https://theoutlier.co.za" target="_blank"
          >The Outlier</a
        >
      </div>
    </div>

    <div id="map" />

    <div class="legend">
      {#each partyLegend as party, i}
        <div class="party">
          <div class="party-box" style="background: {colors[i]};" />
          <div class="party-name">{party}</div>
        </div>
      {/each}
    </div>

    <div class="timeline">
      <div class="timeline-title">
        <img src="./calendar.svg" alt="Calendar" />Events
      </div>
      <div class="timeline-wrap">
        {#each timeline as tl}
          <div class="timeline-row">
            <div class="tl-date">
              {tl.date} - {tl.municipality}{#if tl.province}, {tl.province}{/if}
            </div>
            <div class="tl-description">{tl.brief_description}</div>
            <div class="tl-description">
              {#if tl.previous_party}<span class="timeline-label"
                  >Previous party:</span
                >
                {tl.previous_party}<br />{/if}
              {#if tl.new_party}<span class="timeline-label">New party:</span>
                {tl.new_party}{/if}
            </div>
            {#if tl.source_1 || tl.source_2}
              <div class="tl-sources">
                Links:
                {#if tl.source_1}
                  <a href={tl.source_1} target="_blank">Link 1</a>
                {/if}
                {#if tl.source_2}
                  <a href={tl.source_2} target="_blank">Link 2</a>
                {/if}
              </div>
            {/if}
          </div>
        {/each}
      </div>
    </div>
  </div>
</main>

<style>
  main {
    width: 90%;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
    /* padding-bottom: 50px; */
  }
  .map-container {
    /* border: solid 1px lightgray; */
    position: relative;
    /* margin-top: 50px; */
    margin-bottom: 50px;
  }
  #map {
    width: 100%;
    min-height: 450px;
    margin-left: auto;
    margin-right: auto;
    /* margin-top: 20px; */
    /* border: solid 1px red; */
    padding-top: 100px;
  }
  .map-title {
    position: absolute;
    top: 0px;
    left: 20px;
    font-size: 1.5rem;

    font-weight: 700;
    text-transform: uppercase;
    z-index: 300;
    max-width: 300px;
  }
  .map-subhead {
    font-size: 0.9rem;
    font-weight: 400;
    text-transform: capitalize;
  }

  .tooltip {
    position: fixed;
    z-index: 500;
    background: #fff;
    border: solid 1px lightgray;
    padding: 5px 10px;
    font-size: 0.8rem;
    border-radius: 5px;
    pointer-events: none;
    max-width: 160px;
  }
  .legend {
    display: grid;
    grid-template-columns: 1fr 1fr;
    font-size: 0.8rem;
    padding: 20px;
  }
  .party * {
    display: inline-block;
  }
  .party-box {
    width: 10px;
    height: 10px;
    opacity: 0.6;
  }
  .timeline {
    padding: 20px;
    font-size: 0.9rem;
  }
  .timeline-wrap {
    max-height: 300px;
    overflow-y: auto;
  }
  .tl-date {
    font-weight: 700;
  }
  .timeline-row {
    border-bottom: solid 1px lightgray;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .timeline-label {
    font-weight: 700;
  }
  .timeline-title {
    font-weight: 700;
    font-size: 1.1rem;
    padding-bottom: 5px;
    border-bottom: solid 1px lightgray;
  }
  .timeline-title img {
    margin-right: 10px;
    transform: translate(0px, 5px);
  }
  .logo {
    text-align: left;
    padding-right: 10px;
    padding-top: 0px;
    font-size: 0.8rem;
    color: gray;
    font-weight: 400;
    text-transform: capitalize;
  }

  @media only screen and (max-width: 600px) {
    main {
      width: 100%;
    }
    .legend {
      grid-template-columns: 1fr;
    }
  }
</style>
